import React, { useState, useEffect, Fragment } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";
import { useSelector } from "react-redux";
import HelmetComponent from "../../Components/HelmetComponent";
function FAQS() {
  const { userId, userToken, countryCode } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  return (
    <>
      <HelmetComponent title={`FAQ's`} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  Luxura Cart – Frequently Asked Questions
                </h1>

                <h4>1. What is Luxura Cart?</h4>
                <p>
                  Luxura Cart is an online store that helps you buy high quality international products from the USA
                  and get them delivered to your doorstep in India, without the usual customs and import headaches.
                </p>

                <h4>2. Are all products original and authentic?</h4>
                <p>
                  Yes. We only work with trusted U.S. retailers and brands and import 100% genuine, original products.
                  No fakes, no replicas.
                </p>

                <h4>3. How long does delivery take?</h4>
                <p>
                  Delivery typically takes 10–12 business days. Since products are imported after you place an order,
                  this time includes sourcing, international shipping, customs clearance, and last-mile delivery in
                  India.
                </p>

                <h4>4. Is COD (Cash on Delivery) available?</h4>
                <p>
                  We don’t offer full COD, but we’ve introduced a special option called PPCOD (Prepaid + Cash on
                  Delivery). You pay 30% of the order value in advance to confirm your order, and the remaining 70% in
                  cash at the time of delivery.
                </p>

                <h4>5. Can I cancel my order after placing it?</h4>
                <p>
                  You can cancel your order within 24 hours of placing it. After 24 hours, cancellation is not possible
                  as the product is already being processed for import and dispatch.
                </p>

                <h4>6. Do you offer returns or exchanges?</h4>
                <p>
                  Returns are accepted only if the product is damaged, defective, or the wrong product is delivered. We
                  do not accept returns for change of mind or buyer’s remorse. Please refer to our Return & Refund
                  Policy for details.
                </p>

                <h4>7. How do I track my order?</h4>
                <p>
                  Once your order is shipped, you’ll receive a tracking link via WhatsApp and email, allowing you to
                  view real-time shipment updates.
                </p>

                <h4>8. Do I have to pay any customs duties?</h4>
                <p>
                  No. The price you pay at checkout is inclusive of all duties and taxes. We handle the entire customs
                  process on your behalf.
                </p>

                <h4>9. Can I request a product that’s not listed on your website?</h4>
                <p>
                  Yes. You can contact us via WhatsApp or email with the product name, website link, or a clear image.
                  We’ll check availability and share a quotation.
                </p>

                <h4>10. Are there any hidden charges?</h4>
                <p>
                  No. We follow transparent pricing. The amount shown at checkout is the final amount you pay unless
                  stated otherwise.
                </p>

                <h4>11. Which payment methods are accepted?</h4>
                <p>
                  We accept UPI, debit cards, credit cards, and net banking. Please refer to our Payment & Security
                  Policy for more information.
                </p>

                <h4>12. Is it safe to shop on Luxura Cart?</h4>
                <p>
                  Yes. We use secure, encrypted payment gateways and do not store your full card details on our servers.
                </p>

                <h4>13. Where are you based?</h4>
                <p>We are based in India and source products directly from the United States using trusted partners.</p>

                <h4>14. Do you have a return pickup facility?</h4>
                <p>
                  Yes. For approved returns, we arrange a reverse pickup through our courier partners at no extra cost,
                  subject to serviceability.
                </p>

                <h4>15. What if my product is delayed in customs?</h4>
                <p>
                  We handle customs on your behalf. If there is a delay, we will keep you updated and work with
                  logistics partners to resolve it quickly.
                </p>

                <h4>16. Are electronics compatible with Indian voltage?</h4>
                <p>
                  Some U.S. electronics may not be directly compatible with Indian voltage. Please check specifications
                  before purchase, as a converter or adapter may be required.
                </p>

                <h4>17. Do you offer warranty on products?</h4>
                <p>
                  Warranty depends on the product and brand. Some products have U.S.-only warranties, while others may
                  offer global coverage. Please check product details before purchasing.
                </p>

                <h4>18. Can I change the shipping address after placing the order?</h4>
                <p>
                  You can change the shipping address within 24 hours of placing the order. After that, changes may not
                  be possible.
                </p>

                <h4>19. How do I contact customer support?</h4>
                <p>
                  You can contact us via email at cs@luxuracart.com or through WhatsApp/chat available on our
                  website.
                </p>

                <h4>20. Do you have a mobile app?</h4>
                <p>Not yet. Our website is fully mobile-friendly and works smoothly on smartphones and tablets.</p>

                <h4>21. Do you sell second-hand or refurbished items?</h4>
                <p>No. We only sell brand new, sealed, and original products.</p>

                <h4>22. Is EMI available on purchases?</h4>
                <p>Currently, EMI options are not available. Any updates will be shared on our website.</p>

                <h4>23. What happens if my package is lost in transit?</h4>
                <p>
                  If a package is lost, we will either resend the product (subject to availability) or issue a full
                  refund, based on your preference.
                </p>

                <h4>24. What are your working hours for customer support?</h4>
                <p>Our support team is available from 9:00 AM to 9:00 PM IST, Monday to Saturday.</p>

                <h4>25. What if the product I received is different from the listing?</h4>
                <p>
                  Please share unboxing photos or videos within 24 hours of delivery. Our team will verify and arrange a
                  replacement or refund as per policy.
                </p>

                <h4>26. Do you store my card or payment details?</h4>
                <p>
                  No. All payments are processed via secure, encrypted gateways and we do not store full card details.
                </p>

                <h4>27. Why should I choose Luxura Cart over other sellers?</h4>
                <p>
                  Luxura Cart focuses on trust, transparency, and curated global products. We offer authentic items,
                  all-inclusive pricing, and personalized customer support to make international shopping easy and
                  reliable for customers in India.
                </p>

                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQS;
